import { Trans } from '@lingui/macro';
import { get } from 'lodash';
import { useVoipPulseAgents } from './UseVoipPulseAgents';
import { CallSettingsFieldSection } from './CallSettingsFieldSection';
import { AgentDetailsSection } from './AgentDetailsSection';
import TestFormSection from '../TestFormSection/TestFormSection';

/**
 * Determine if details section should be shown for an agent.
 * Mirrors portal/ui: show when agent has a call manager or uses direct calling.
 */
function shouldShowDetails(agent) {
    if (!agent) return false;
    return (
        !!get(agent, 'voipConfiguration.primaryCallManager.name') || !!get(agent, 'voipConfiguration.useDirectCalling')
    );
}

export const VoipPulseCallSettingsSection = () => {
    const { agentsById, selectedCallerId, selectedCalleeId } = useVoipPulseAgents();

    const callerAgent = selectedCallerId ? agentsById[selectedCallerId] : null;
    const calleeAgent = selectedCalleeId ? agentsById[selectedCalleeId] : null;

    return (
        <TestFormSection title={<Trans>Call Settings</Trans>}>
            {shouldShowDetails(callerAgent) && (
                <AgentDetailsSection agent={callerAgent} title={<Trans>Caller nPoint Configuration</Trans>} />
            )}
            {shouldShowDetails(calleeAgent) && (
                <AgentDetailsSection agent={calleeAgent} title={<Trans>Callee nPoint Configuration</Trans>} />
            )}
            <CallSettingsFieldSection />
        </TestFormSection>
    );
};
